module.exports = __webpack_public_path__ + "img/cake-intro-x30.a86baa5a.png";